var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 30,
    viewBox: "0 0 19 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 30C4.20502 30 0 25.795 0 20.625V7.5C0 6.80878 0.560074 6.25008 1.24992 6.25008C1.94 6.25008 2.50008 6.80878 2.50008 7.5V20.625C2.50008 24.4151 5.5838 27.4999 9.375 27.4999C13.1662 27.4999 16.2499 24.4151 16.2499 20.625V6.87492C16.2499 4.46251 14.2875 2.50008 11.8751 2.50008C9.46243 2.50008 7.5 4.46251 7.5 6.87492V19.3751C7.5 20.4087 8.34114 21.2501 9.375 21.2501C10.4089 21.2501 11.25 20.4087 11.25 19.3751V7.5C11.25 6.80878 11.8101 6.25008 12.4999 6.25008C13.19 6.25008 13.7501 6.80878 13.7501 7.5V19.3751C13.7501 21.7875 11.7874 23.7499 9.375 23.7499C6.96259 23.7499 4.99992 21.7875 4.99992 19.3751V6.87492C4.99992 3.0851 8.08365 0 11.8751 0C15.6663 0 18.75 3.0851 18.75 6.87492V20.625C18.75 25.795 14.545 30 9.375 30Z",
    fill: "#BD0707"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ae223693db2536447b29b97fa692fa57.svg";
export { ForwardRef as ReactComponent };